import store from '@/store/store'
import api from '@/services/api'

import { pages } from '@/router'
import { getCustomDomainTourId } from '@/shared/domains'

let responseData = undefined

const navigationGuards = (data, to, next) => {
	let {
		name, 
		params: { id },
		query: { branded }
	} = to

	if (getCustomDomainTourId()) {
		id = getCustomDomainTourId()
	}

	const { settings: { sold, enabled } } = data
	const layoutType = store.getters['tours/getLayoutType']

	// Tour disabled
	if (!enabled && !sold) {
		next({name: 'notFound'})
		return
	}

	// Disabled sold
	if (!sold && name === 'sold') {
		next({name: 'notFound'})
		return
	}

	// Tour sold after redirect to /sold/:id
	if (sold && name === 'sold') {
		next()
		return
	}

	// Tour sold before redirect
	if (sold) {
		next({name: 'sold', params: {id}})
		return
	}

	// Tour one-page
	if (name === 'onePage' && layoutType === 'one') {
		next()
		return
	}

	// Tour one-page that starts from /xxxx/:id
	if (pages.includes(name) && layoutType === 'one') {
		next({
			name: 'onePage', 
			params: {id},
			query: {
				branded: branded 
					? branded 
					: 0
			}
		})

		return
	}

	// Tour multi-page that starts from /:id
	if (name === 'onePage' && layoutType === 'multi') {
		const pageName = pages.find(page => {
			if (data.settings[page]) {
				return page
			}
		})

		next({
			name: pageName, 
			params: { id },
			query: {
				branded: branded 
					? branded 
					: 0
			}
		})

		return
	}

	// Tour multi-page
	if (data.settings[name]) {
		next()
		return
	}

	// Contact multi-page
	if (+branded && name === 'contact' && layoutType === 'multi') {
		next()
		return
	}

	next({name: 'notFound'})
	return
}

export default {
	beforeRouteEnter (to, from, next) {
		if (responseData) {
			return navigationGuards(responseData, to, next)
		}

		let { params: { id } } = to

		if (getCustomDomainTourId()) {
			id = getCustomDomainTourId()
		}

		api.tours.getTourById(id).then(async response => {
			responseData = response.data.tour

			if (responseData) {
				await store.dispatch('tours/getTourSuccess', responseData)

				return navigationGuards(responseData, to, next)
			}

			store.dispatch('tours/getTourFailure')
			next({name: 'notFound'})
		})
		.catch(() => {
			store.dispatch('tours/getTourFailure')
			next({name: 'notFound'})
		})
	}
}
